const isInternalPath = () =>
    window.gtxLoggedUser.idAgente &&
    window.location.href.indexOf('/login/a2f') === -1 &&
    window.location.href.indexOf('/check-status/tos') === -1;

module.exports = isInternalPath;
